{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/freeform",
	"title": "Classic",
	"category": "text",
	"description": "Use the classic WordPress editor.",
	"textdomain": "default",
	"attributes": {
		"content": {
			"type": "string",
			"source": "raw"
		}
	},
	"supports": {
		"className": false,
		"customClassName": false,
		"lock": false,
		"reusable": false,
		"renaming": false,
		"visibility": false
	},
	"editorStyle": "wp-block-freeform-editor"
}
